import { useContext } from 'react'
import { ContactSellerModalContext } from './context/ContactSellerContext'

function BidButton() {
  return (
    <a
      className="btn btn-primary w-100 ga-event px-2 rounded-8"
      data-ga-event={JSON.stringify({
        category: 'Car Page',
        action: 'Click Bid',
      })}
      href={App.State.bidUrl}
      target="_blank"
      rel="nofollow noreferrer"
    >
      <i className="far fa-gavel me-1" />
      <span>Bid</span>
    </a>
  )
}

function ContactButton({ openContactModal }) {
  return (
    <button
      type="button"
      className="btn btn-primary w-100 ga-event px-2 rounded-8"
      aria-label="Contact seller"
      disabled={App.State.carOwner}
      data-ga-event={JSON.stringify({
        category: 'Car Page',
        action: 'Click Email (mobile)',
      })}
      onClick={() => openContactModal()}
    >
      <i className="far fa-envelope fa-lg me-1" />
    </button>
  )
}

function ContactSellerButtonMobile() {
  const { openContactModal } = useContext(ContactSellerModalContext)

  return App.State.biddingAllowed ? (
    <BidButton />
  ) : (
    <ContactButton openContactModal={openContactModal} />
  )
}

export default ContactSellerButtonMobile
